import { nextFloat, seedRng } from '../../shared/prng';
import { DOME_SCALE as SCALE } from '../../data/full/dome';
import type { ObstacleDefinition } from '../../data/types';
import type { Vec2 } from '../../shared/vec';

export interface Light {
  readonly x: number;
  readonly y: number;
  readonly radius: number;
  readonly group: number;
}

export const RIBS = 24;
export const TWINKLE_GROUPS = 3;
export const RING = 300 * SCALE;
export const RIB_FROM = 56 * SCALE;
export const PANELS = { from: 252 * SCALE, to: 280 * SCALE } as const;
const LIGHTS = { from: 74 * SCALE, to: 232 * SCALE } as const;

export function crownPosts(
  obstacles: readonly ObstacleDefinition[],
  center: Vec2,
): readonly ObstacleDefinition[] {
  const distance = (o: ObstacleDefinition): number => Math.hypot(o.x - center.x, o.y - center.y);
  const ring = Math.min(...obstacles.map(distance));
  return obstacles.filter((o) => distance(o) < ring * 1.1);
}

export function garlands(seed: number, center: Vec2): readonly Light[] {
  const rng = seedRng(seed);
  const step = (Math.PI * 2) / RIBS;
  const lights: Light[] = [];
  for (let rib = 0; rib < RIBS; rib += 1) {
    for (let r = LIGHTS.from; r < LIGHTS.to; r += 11 * SCALE) {
      if (nextFloat(rng) < 0.55) {
        const angle = rib * step + step * (0.15 + nextFloat(rng) * 0.7);
        lights.push({
          x: center.x + Math.cos(angle) * r,
          y: center.y + Math.sin(angle) * r,
          radius: 0.9 + nextFloat(rng) * 1.3,
          group: nextFloat(rng) < 0.3 ? 1 + Math.floor(nextFloat(rng) * TWINKLE_GROUPS) : 0,
        });
      }
    }
  }
  return lights;
}
